<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-dialog-title>{{'Edit Transport' | translate: ['tmc.transport.edit.title',
    translationService.language]}}</sc-dialog-title>
  <sc-flex-fitting-content [vertical]="true">
    <sc-padding [fitHeight]="true">
      <ng-container *ngIf="editTransport != null && editTransport.transport != null">
        <mat-tab-group style="height: 100%;">
          <mat-tab
            label="{{'protocoll' | translate: ['tmc.transport.edit.tab.masterdata', translationService.language]}}">
            <sc-scroll-pane>
              <app-transport-details [mode]="TransportDetailMode.EDITING" [transport]="editTransport.transport"
                [layout]="layout">
              </app-transport-details>
            </sc-scroll-pane>
          </mat-tab>
          <mat-tab
            label="{{'protocoll' | translate: ['tmc.transport.edit.tab.transport-options', translationService.language]}}">
            <sc-scroll-pane>
              <div class="tab-content">
                <app-transport-options-panel [model]="model"></app-transport-options-panel>
                <div class="form-box"
                  *ngIf="editTransport.transport.masterdata.managementLevel !== TransportManagementLevel.LIFECYCLE">
                  <mat-checkbox class="options-checkbox" [(ngModel)]="editTransport.restartRouting"
                    [disabled]="!editTransport.restartRoutingPossible || !this.editTransport.optionsChanged">
                    {{'restart Route' |
                    translate:['tmc.transport.edit.restartRouting',translationService.language]}}
                  </mat-checkbox>
                </div>
              </div>
            </sc-scroll-pane>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
    </sc-padding>
  </sc-flex-fitting-content>
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-padding>
    <div [formGroup]="formGroup">
      <sc-flex>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <ng-container *ngIf="editTransport?.inPlanningMode">
          <sc-checkbox-field formControlName="registerArrival" [disabled]="!editTransport.inPlanningMode" [label]="'register arrival' | translate : ['tmc-yard.widgets.transport-registration.checkbox.register-arrival',
            translationService.language]" formControlName="registerArrival"></sc-checkbox-field>
          <sc-content-spacer></sc-content-spacer>
          <sc-checkbox-field [label]="'register entrance' | translate : ['tmc.transport.edit.registerEntrance',
            translationService.language]" formControlName="registerEntrance">
          </sc-checkbox-field>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
        </ng-container>
        <button mat-stroked-button (click)="cancel()">{{'cancel' | translate:
          ['tmc.transport.edit.action.cancel', translationService.language]}}</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="save()" [disabled]="isSaveDisabled()">{{'save' |
          translate:
          ['tmc.transport.edit.action.save', translationService.language]}}</button>
      </sc-flex>
    </div>
  </sc-padding>
</sc-flex>